/**
 *
 * @license
 * Copyright 2017 SAP Ariba
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 *
 *
 */
/**
 * Represents an event triggered when a page has been initialized.
 *
 */
export class PageInitialized
{
    constructor(public title: string)
    {
    }

    toString(): string
    {
        return `PageInitializied(title: ${this.title})`;
    }
}

/**
 * Represents an event triggered when a page has been destroyed.
 *
 */
export class PageDestroyed
{
    constructor(public title: string)
    {
    }

    toString(): string
    {
        return `PageDestroyed(title: ${this.title})`;
    }
}

export type PageEvent = PageInitialized | PageDestroyed;
